import { LoginPage } from './../../../login/login/login';
import { QRCodePage } from './../../../me/qrcode/qrcode';
import { SessionProvider } from './../../../../providers/session/session';
import { Component } from '@angular/core';
import { EventProvider } from '../../../../providers/event/event';
import { ModalController, NavController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'page-event-tester',
  templateUrl: 'event-tester.html',
  styleUrls:['./event-tester.scss']
})
export class EventTester {
  constructor(
    private sessionService: SessionProvider,
    private eventService: EventProvider,
    private navController: NavController,
    private modalCtrl: ModalController,
    private router:Router
    ){ 
      this.navController.navigateForward('/auth/login');
      // this.navController.push(LoginPage);

    }

    checkIn(){
    this.sessionService.getToken().then(token => {
      // this.event.id
      this.eventService.getQRCode(token, -1).then(qrcode => {
        this.navController.navigateForward('/me/qrcode',{state:{qrcode:qrcode.content}});
        // (this.app.getActiveNav() as NavController).push(QRCodePage, { qrcode: qrcode.content });
      });
    });
  }
}

